import Vue from 'vue';

import './pixel';
// import './sessionRecord';
import './ga';
import './hubspot';

export const stopTracking = () => {
    // Vue.fbq = (...args) => console.log('fbq', args);

    Vue.use({
        install(Vue) {
            Vue.prototype.$gtag = {
                event(action, { ...args }) {
                    console.log('ga event', action, args);
                },
                config(...args) {
                    console.log('ga config', args);
                },
                linker(...args) {
                    console.log('ga linker', args);
                },
            };
        },
    });
};
